module.exports = __webpack_public_path__ + "static/img/login_cd.6eccd57e.png";